export enum PrinterTypes {
  NO_PRINTER = 'NO_PRINTER',
  WIN_API_PDF = 'WIN_API_PDF',
  POSNET = 'POSNET',
}
